"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewResetSecret extends new_item_1.default {
    constructor(newResetSecret) {
        super();
        this.applicationId = newResetSecret.applicationId;
        this.password = newResetSecret.password;
        this.clientSecret = newResetSecret.clientSecret;
    }
}
exports.default = NewResetSecret;
//# sourceMappingURL=new-resetSecret.js.map